import {
  Button,
  CloseButton,
  Heading,
  Link,
  LoadingSpinner,
  Logo,
  ScrollView,
  Text,
  XStack,
  YStack,
} from "@/components";

type MessageProps = {
  title: string;
  subtitle?: string;
};

export const SidebarPendingState = ({
  onClose,
  message,
  ctaLabel,
  onCtaPress,
  showSupportLink,
  hideHeader,
  hideCloseButton,
}: {
  onClose: () => void;
  message?: MessageProps;
  ctaLabel?: string;
  onCtaPress?: () => void;
  showSupportLink?: boolean;
  hideHeader?: boolean;
  hideCloseButton?: boolean;
}) => {
  let content;

  if (!message) {
    content = (
      <>
        <LoadingSpinner size={72} />
        <YStack>
          <Text textAlign="center" bold>
            Please stand by
          </Text>
          <Text textAlign="center" color="$textSecondary">
            It'll only take a moment...
          </Text>
        </YStack>
      </>
    );
  } else {
    content = (
      <YStack gap="$250" alignItems="center" width="100%">
        <YStack gap="$100" alignItems="center">
          <Heading size="$md" textAlign="center">
            {message.title}
          </Heading>

          {message.subtitle && (
            <Text size="$sm" color="$textSecondary" textAlign="center">
              {message.subtitle}
            </Text>
          )}
        </YStack>
      </YStack>
    );
  }

  return (
    <YStack
      height="100%"
      borderRadius="$150"
      backgroundColor="$fillModal"
      padding="$200"
    >
      <ScrollView
        flex={1}
        contentContainerStyle={{
          flex: 1,
        }}
      >
        <YStack flex={1} position="relative">
          {!hideHeader && (
            <>
              {!hideCloseButton && (
                <CloseButton
                  onClose={onClose}
                  dataTrackingId="sidebar-pending-close"
                />
              )}
              <XStack
                position="absolute"
                left={0}
                right={0}
                alignItems="center"
                justifyContent="center"
                pointerEvents="none"
              >
                <Logo />
              </XStack>
            </>
          )}

          <YStack
            flex={1}
            justifyContent="center"
            alignItems="center"
            padding="$400"
            gap="$200"
          >
            {content}
          </YStack>
        </YStack>
      </ScrollView>

      {ctaLabel && onCtaPress && (
        <Button
          mode="primary"
          onPress={onCtaPress}
          width="100%"
          marginTop="$200"
        >
          {ctaLabel}
        </Button>
      )}

      {showSupportLink && (
        <YStack
          marginTop="$200"
          marginBottom="$100"
          height={40}
          justifyContent="center"
          alignItems="center"
        >
          <Text size="$sm" color="$textSecondary" alignSelf="center">
            Having trouble?{" "}
            <Link
              size="$sm"
              bold
              href="https://www.curaihealth.com/support"
              external
            >
              Contact support
            </Link>
          </Text>
        </YStack>
      )}
    </YStack>
  );
};
